import { discriminatedUnion, literal, nativeEnum, number, object, preprocess } from 'zod';

import { IS_POSITIVE, IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';
import { Award_Per_Counting_Strategy } from '@occc/graphql';
import { ProductGroupsSchema } from '@occc/validation';

import { BasePromotionSchema } from './base-promotion.schema';

import { ProductDiscountAwardType, PromotionType } from '../types';

const ProductDiscountBaseSchema = object({
  purchaseThreshold: number({ required_error: IS_REQUIRED }).gt(0, { message: IS_POSITIVE }),
  eligibleProductGroups: ProductGroupsSchema,
});

export const ProductDiscountEarningMechanismSchema = discriminatedUnion('awardType', [
  ProductDiscountBaseSchema.extend({
    awardType: literal(ProductDiscountAwardType.Free),
    moneyAmount: number().optional(),
  }),
  ProductDiscountBaseSchema.extend({
    awardType: literal(ProductDiscountAwardType.Discount),
    moneyAmount: number({ required_error: IS_REQUIRED }).positive(IS_POSITIVE),
    countProductsBy: nativeEnum(
      {
        IndividualPurchase: Award_Per_Counting_Strategy.IndividualPurchase,
        SellingUnitPurchase: Award_Per_Counting_Strategy.SellingUnitPurchase,
      } as const,
      { required_error: IS_REQUIRED },
    ),
  }),
  ProductDiscountBaseSchema.extend({
    awardType: literal(ProductDiscountAwardType.PriceOverride),
    moneyAmount: number({ required_error: IS_REQUIRED }).gt(0, { message: IS_POSITIVE }),
  }),
]);

export const ProductDiscountFormSchema = BasePromotionSchema.extend({
  offerType: literal(PromotionType.ProductDiscount),
  productDiscount: preprocess((val) => val ?? {}, ProductDiscountEarningMechanismSchema),
});
